import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../../config'
import {
    GET_ANALYSTS_LIST,
    getAnalystsListSuccess,
    DELETE_ANALYST,
    deleteAnalystFailure,
    getAnalystsList

} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from "../../../components/Utils/httpHelper";


export function* analystsList(action) {
    let requestURL = `${AUTH_SERVER}/user/analyst/list`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(getAnalystsListSuccess(result.data));
    } catch (err) {
        yield put(getAnalystsListSuccess(err))
    }
}
export function* getAnalystsListSaga() {
    yield takeLatest(GET_ANALYSTS_LIST, analystsList);
}

export function* delAnalyst(action) {
    let requestURL = `${AUTH_SERVER}/user/analyst/${action.id}`;
    try {
        yield call(request, requestURL, { data: action.data, method: 'DELETE', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(getAnalystsList());

    } catch (err) {
        yield put(deleteAnalystFailure(err))
    }
}
export function* deleteAnalyst(id) {
    yield takeLatest(DELETE_ANALYST, delAnalyst);
}
